import { FileDownloadOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import moment from "moment";
import React from "react";
import { toast } from "react-toastify";
import { useLazyGetCOCUserReportDetailQuery } from "store/services/reportApi";
import { exportExcelFile } from "utils/exportExcelFile";

const ExportUserCOCReportDetail = ({ userId }) => {
  const [fetchCOCUserReportDetail, { isLoading, isFetching }] =
    useLazyGetCOCUserReportDetailQuery();

  const handleDownload = async (data) => {
    try {
      const responseData = await fetchCOCUserReportDetail({
        userId,
      }).unwrap();

      if (!responseData?.data || responseData.data.length === 0) {
        toast.info("No data.");
        return;
      }

      const formattedData = responseData?.data.map((row, index) => ({
        SN: index + 1,
        "Responsible User": row.responsibleUser?.name || "N/A",
        "Shipment Id": row.shipmentId || "N/A",
        Charge: row.charge || "N/A",
        Status: row.paymentStatus || "N/A",
        Date: row.createdAt
          ? moment(row.createdAt).format("YYYY-MM-DD")
          : "N/A",
      }));

      exportExcelFile({
        sheetData: formattedData,
        fileName: "COC_User_Report_Detail",
      });
      toast.success("Data downloaded successfully");
    } catch (error) {
      toast.error("Error fetching COC user report data: " + error.message);
    }
  };

  return (
    <div>
      <Tooltip title="Export Excel" arrow>
        <IconButton
          color="success"
          onClick={handleDownload}
          disabled={isLoading || isFetching}
        >
          <FileDownloadOutlined />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default ExportUserCOCReportDetail;
